// Scroll to form field when the validation fails
import $ from 'jquery';
jQuery.noConflict();

export function scrollToInput(inputSelector) {
    $(inputSelector).on('click', function () {
    var $validationFailed = $('.validation-failed');
    if ($validationFailed.length > 0) {
            var fieldId = $validationFailed.first().attr("id");
            document.getElementById(fieldId).scrollIntoView({behavior: 'smooth', block: 'center'});
        }
    });
}